<script setup>
import { computed } from 'vue';

// Custom filled-star rating (Golden Sand) — mirrors components/core/Rating.
const props = defineProps({
  value: { type: Number, default: 5 },
  count: { type: Number, default: null },
});

const full = computed(() => Math.round(props.value));
</script>

<template>
  <span class="gm-rating">
    <span class="gm-stars">
      <span
        v-for="i in 5"
        :key="i"
        :class="{ empty: i > full }"
        aria-hidden="true"
      >
        <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2.5l2.9 5.88 6.49.94-4.7 4.58 1.11 6.46L12 17.9l-5.8 3.05 1.1-6.46-4.7-4.58 6.5-.94L12 2.5z" />
        </svg>
      </span>
    </span>
    <b>{{ value.toFixed(1) }}</b>
    <span v-if="count != null" class="cnt">({{ count }})</span>
  </span>
</template>
